import BaseComponent from '../../components/base-component/base-component'
import { bodyElement } from '../../components/common/body-element'
import { parseHTML } from '../../utils/dom'

class ProductRelatedBlock extends BaseComponent {
  connectedCallback() {
    this.loadProducts()
  }

  loadProducts() {
    this.setAttribute('is-loading', '')

    return fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = parseHTML(text)

        this.updateByHTML(html)

        this.removeAttribute('is-loading')
      })
      .catch(() => {
        if (!bodyElement.notification) {
          return
        }

        bodyElement.notification.show(
          'Error in product recommendations component',
          'warning',
        )
      })
  }

  updateByHTML(html: Document): void {
    const recommendations = html.getElementById(this.id)

    if (recommendations) {
      const clonedRecommendations = recommendations.cloneNode(true)

      this.replaceChildren(...clonedRecommendations.childNodes)

      this.toggleAttribute('is-ready', this.hasChildNodes())
    }
  }
}

export default ProductRelatedBlock
